import {Injectable} from '@angular/core';
import { get, set } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export abstract class UserPrefs {
  public readonly defaultSettings = {
    alertsPreferenceEnabled: false,
    alertsPreference: {
      timeZone: "Etc/UTC",
      emailDigestConfig: {
        isEnabled: false,
        timePeriod: 'AM',
        digestTime: {
          hour: 0,
          min: 0
        }
      },
      sendEmailImmediately: false,
      enableOverallEmailAlerts: false,
      isSmsNotificationEnabled: false,
      emailFormat: "html"
    },
    enableWebUIAlerts: false,
    theme: "light"
  };
  userSettings: any = this.defaultSettings;

  protected constructor() {
  }

  setSettings(settings: any) {
    set(this, 'userSettings', settings);
  }

  setTimeZone(zone: string) {
    set(this.userSettings, 'alertsPreference.timeZone', zone);

    // Return updated object full pth for update to API
    return {alertsPreference: {timeZone: zone}};
  }

  setEmailDigestTimeTimePeriod(period: string) {
    set(this.userSettings, 'alertsPreference.emailDigestConfig.timePeriod', period);

    return {alertsPreference: {emailDigestConfig: {timePeriod: period}}};
  }

  setEmailNotification(isEnabled: boolean) {
    set(this.userSettings, 'alertsPreference.enableOverallEmailAlerts', isEnabled);

    return {alertsPreference: {enableOverallEmailAlerts: isEnabled}};
  }

  setSmsNotification(isEnabled: boolean) {
    set(this.userSettings, 'alertsPreference.isSmsNotificationEnabled', isEnabled);

    return {alertsPreference: {isSmsNotificationEnabled: isEnabled}};
  }

  setSendEmailImmediately(isEnabled: boolean) {
    set(this.userSettings, 'alertsPreference.sendEmailImmediately', isEnabled);

    return {alertsPreference: {sendEmailImmediately: isEnabled}};
  }

  setEmailFormat(format: string) {
    set(this.userSettings, 'alertsPreference.emailFormat', format);

    return {alertsPreference: {emailFormat: format}};

  }

  setEmailDigest(isEnabled: boolean) {
    set(this.userSettings, 'alertsPreference.emailDigestConfig.isEnabled', isEnabled);

    return {alertsPreference: {emailDigestConfig: {isEnabled}}};
  }

  setEmailDigestTime(hour: number, min: number) {
    set(this.userSettings, 'alertsPreference..emailDigestConfig.digestTime.hour', hour);
    set(this.userSettings, 'alertsPreference..emailDigestConfig.digestTime.min', min);

    return {
      alertsPreference: {
        emailDigestConfig: {
          digestTime: {
            hour,
min
          }
        }
      }
    };
  }

  setWebUIAlerts(isEnabled: boolean) {
    set(this.userSettings, 'enableWebUIAlerts', isEnabled);

    return {
      enableWebUIAlerts: isEnabled
    };
  }

  setAlertsPref(isEnabled: boolean) {
    set(this.userSettings, 'alertsPreferenceEnabled', isEnabled);

    return {alertsPreferenceEnabled: isEnabled};
  }

  setTheme(theme: string) {
    set(this.userSettings, 'theme', theme);

    return {theme};
  }

  getTheme() {
    return get(this.userSettings, 'theme', 'light');
  }

  chooseSaveObjectByName(name: string, value: any) {
    switch (name) {
      case 'emailFormatSelected': {
        return this.setEmailFormat(value);
      }
      case 'emailTimeZoneSelected': {
        return this.setTimeZone(value);
      }
      case 'digestEmailTimeSelected': {
        const splitedNumbers = value.split(':');
        const hour = Number(splitedNumbers[0]);
        const minutes = Number(splitedNumbers[1]);

        return this.setEmailDigestTime(hour, minutes);
      }
      case 'digestEmailMeridiemOffsetSelected': {
        return this.setEmailDigestTimeTimePeriod(value);
      }
      case 'enableOverallEmailAlerts': {
        return this.setAlertsPref(value);
      }
      case 'enableEmailNotification': {
        return this.setEmailNotification(value);
      }
      case 'enableSendImmediate': {
        return this.setSendEmailImmediately(value);
      }
      case 'enableDailyDigest': {
        return this.setEmailDigest(value);
      }
      case 'enableWebUIAlerts': {
        return this.setWebUIAlerts(value);
      }
      default:
        throw new Error(`Not implemented user pref (${name})`);
    }
  }

}

